import { render, staticRenderFns } from "./DragTargetView.vue?vue&type=template&id=49995684&scoped=true&"
import script from "./DragTargetView.vue?vue&type=script&lang=js&"
export * from "./DragTargetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49995684",
  null
  
)

export default component.exports